/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations
 * or external files from CMS`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

export function LanguageProvider(props) {
  return (
    <IntlProvider
      locale={props.language.locale}
      key={props.language.locale}
      defaultLocale="it"
      messages={props.language.messages[props.language.locale]}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}


LanguageProvider.propTypes = {
  language: PropTypes.object,
  children: PropTypes.element.isRequired,
};

LanguageProvider.defaultProps = {
  language: {},
};


export default LanguageProvider;
